import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { DynamicFormControl } from '../../models/dynamic-form-control.model';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { FilterService } from 'src/app/shared/filtering';
import { FormControlFactory } from '../../services/form-control-factory.service';

@Component({
  selector: 'lib-customer-input-control',
  imports: [MatInputModule, ReactiveFormsModule, FormsModule],
  templateUrl: './customer-input-control.component.html',
  styleUrl: './customer-input-control.component.scss',
})
export class CustomerInputControlComponent {
  @Input() custControl: DynamicFormControl;
  @Input() isReadonly: boolean;
  inputControl: FormControl;

  private _subscriptions: Subscription[] = [];

  constructor(
    private filterService: FilterService,
    public formControlService: FormControlFactory,
  ) {}

  ngOnInit() {
    this.inputControl = this.custControl.formControls[0].formControl;

    let sub = this.filterService.activeFilterRemoved$.subscribe({
      next: (i) => {
        if (i.propertyBinding === this.custControl.propertyBinding) {
          this.custControl.formControls[0].formControl.setValue(null);
        }
      },
      error: (e) => console.log(e),
    });

    this._subscriptions.push(sub);
  }

  ngOnDestroy() {
    this._subscriptions.forEach((i) => i.unsubscribe());
  }

  /** On blur, formats the value to titleCase so editing keystrokes don't disturb the caret. */
  onInputBlur(event: any) {
    const value = event?.target?.value;
    if (!value) return;
    const formatted = this.formControlService.toTitleCase(value);
    if (formatted !== value) {
      this.inputControl?.setValue(formatted);
    }
  }
}
